<template>
  <div class='myPostIndex'>
    <div
      class='cont'
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0)"
    >
      <el-select
        v-model="selectType"
        placeholder="请选择用户身份"
        @change="changeRoleLable"
      >
        <el-option
          v-for="item in selectTypeArray"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-row :gutter="40">

        <el-col :span="8">
          <el-card shadow="hover">
            <div
              slot="header"
              class="clearfix"
            >
              <span>总注册用户</span>
            </div>
            {{content.totalUser}}
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover">
            <div
              slot="header"
              class="clearfix"
            >
              <span>{{selectType === 'day' ? '当天' : ''}}{{selectType === 'week' ? '本周' : ''}}{{selectType === 'month' ? '本月' : ''}}新增用户</span>
            </div>
            {{content.todayUser}}
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover">
            <div
              slot="header"
              class="clearfix"
            >
              <span>{{selectType === 'day' ? '昨天' : ''}}{{selectType === 'week' ? '上周' : ''}}{{selectType === 'month' ? '上月' : ''}}新增用户</span>
            </div>
            {{content.yesterdayUser}}
          </el-card>
        </el-col>

        <el-col :span="8">
          <el-card shadow="hover">
            <div
              slot="header"
              class="clearfix"
            >
              <span>总发布职位数</span>
            </div>
            {{content.jobTotalNumber}}
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover">
            <div
              slot="header"
              class="clearfix"
            >
              <span>{{selectType === 'day' ? '当天' : ''}}{{selectType === 'week' ? '本周' : ''}}{{selectType === 'month' ? '本月' : ''}}发布职位</span>
            </div>
             {{content.jobTodayNumber}}
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover">
            <div
              slot="header"
              class="clearfix"
            >
              <span>{{selectType === 'day' ? '昨天' : ''}}{{selectType === 'week' ? '上周' : ''}}{{selectType === 'month' ? '上月' : ''}}发布职位数</span>
            </div>
             {{content.jobYesterdayNumber}}
          </el-card>
        </el-col>

        <el-col :span="8">
          <el-card shadow="hover">
            <div
              slot="header"
              class="clearfix"
            >
              <span>总收入佣金金额</span>
            </div>
            {{content.totalBackMoney}}
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover">
            <div
              slot="header"
              class="clearfix"
            >
              <span>总支出佣金金额</span>
            </div>
            {{content.totalExpendMoney}}
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover">
            <div
              slot="header"
              class="clearfix"
            >
              <span>{{selectType === 'day' ? '当天' : ''}}{{selectType === 'week' ? '本周' : ''}}{{selectType === 'month' ? '本月' : ''}}收入佣金金额</span>
            </div>
            {{content.todayBackMoney}}
          </el-card>
        </el-col>

        <el-col :span="8">
          <el-card shadow="hover">
            <div
              slot="header"
              class="clearfix"
            >
              <span>{{selectType === 'day' ? '昨天' : ''}}{{selectType === 'week' ? '上周' : ''}}{{selectType === 'month' ? '上月' : ''}}收入佣金金额</span>
            </div>
           {{content.yesterdayBackMoney}}
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover">
            <div
              slot="header"
              class="clearfix"
            >
              <span>{{selectType === 'day' ? '当天' : ''}}{{selectType === 'week' ? '本周' : ''}}{{selectType === 'month' ? '本月' : ''}}支出佣金金额</span>
            </div>
            {{content.todayExpendMoney}}
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover">
            <div
              slot="header"
              class="clearfix"
            >
              <span>{{selectType === 'day' ? '昨天' : ''}}{{selectType === 'week' ? '上周' : ''}}{{selectType === 'month' ? '上月' : ''}}支出佣金</span>
            </div>
              {{content.yesterdayExpendMoney}}

          </el-card>
        </el-col>

      </el-row>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import Config from "../config/index";
export default {
  name: "ptStatus",
  props: {},
  data() {
    return {
      loading: false,
      content: null,
      selectTypeArray: [
        {
          value: "day",
          label: "今天"
        },
        {
          value: "week",
          label: "本周"
        },
        {
          value: "month",
          label: "本月"
        }
      ],
      selectType: "day"
    };
  },
  watch: {},
  created: function() {},
  methods: {
    changeRoleLable: function() {
      this.getPostList();
    },
    getPostList: function() {
      let that = this;
      that.loading = true;

      axios({
        method: "POST",
        url: Config.path + "/api/platform/user/selectStatistics",
        headers: {
          token: localStorage.getItem("token"),
          "content-type": "application/json"
        },
        data: {
          selectType: this.selectType
        }
      })
        .then(res => {
          that.loading = false;
          if (res.data.success === "1") {
            that.content = res.data.content;
          } else if (response.data.success === "111111") {
            that.$router.push({
              path: "/login"
            });
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch(err => {
          that.loading = false;
          that.$message.error("无法连接网络,请检查WiFi或移动数据网络是否正常");
        });
    }
  },
  mounted: function() {
    this.getPostList();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.myPostIndex {
  width: 100vw;
  height: calc(100vh - 100px);
  padding-top: 1px;
  position: relative;
  .paginationBox {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    // background-color: rgb(83, 152, 133);
    width: max-content;
    padding: 5px 40px;
    z-index: 9999;
    border-radius: 10px;
    .el-pager {
      li {
        background: transparent;
        color: #ffffff;
      }

      .active {
        background: #fff;
        color: #5dc2d0;
      }
    }

    .el-pagination .btn-prev,
    .el-pagination .btn-next {
      background-color: transparent;

      i {
        color: #ffffff;
      }
    }
  }

  .cont {
    width: calc(100% - 60px);
    height: calc(100vh - 200px);
    background-color: #ffffff;
    border-radius: 8px;
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 30px;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    overflow: hidden;
    overflow-y: scroll;

    // .selectCont {

    //     .el-radio-group {
    //         margin-left: 40px;

    //         .el-radio-button__inner {
    //             background-color: transparent;
    //             color: #fff;
    //         }

    //         .is-active {
    //             .el-radio-button__inner {
    //                 background-color: #ffffff;
    //                 color: #5DC2D0;
    //                 border-color: #5DC2D0;
    //             }
    //         }
    //     }
    // }

    // .tableCont {
    //     margin-top: 30px;

    //     * {
    //         background-color: transparent;
    //         color: #ffffff;
    //     }

    //     .el-table--group,
    //     .el-table--border {
    //         border: none;

    //         &:after {
    //             border: none;
    //         }
    //     }

    //     .el-table--group,
    //     .el-table--border {
    //         border: none;
    //     }

    //     .el-table--border th,
    //     .el-table--border td {
    //         border: none;
    //     }

    //     .el-table--group::after,
    //     .el-table--border::after,
    //     .el-table::before {
    //         height: 0;
    //         width: 0;
    //     }

    //     .el-table__header-wrapper {
    //         border-bottom: 1px solid #ffffff;
    //     }

    //     .el-table__body tr {
    //         >td {
    //             span {
    //                 margin: 0 5px;
    //             }
    //         }

    //         &:hover {
    //             >td {
    //                 background-color: #ffffff;

    //                 div {
    //                     color: #5DC2D0;
    //                 }

    //                 span {
    //                     color: #5DC2D0;
    //                     margin: 0 5px;
    //                 }
    //             }
    //         }
    //     }
    // }
  }
  .dsbox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
  }
  .el-col{
    padding: 20px;
  }
  .el-card__body{
    text-align: center;
  }
}
</style>
